import styled from 'styled-components';
import { Flex, TableWitPagination } from 'dash-ui';

export const StyledTable = styled(TableWitPagination)`
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  background-color: ${({ theme }) => theme.colors.white};
  & table {
    & tbody {
      & tr {
        &:hover td {
          &:last-child > div {
            visibility: visible;
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.devices.mobile} {
    & > div > div {
      &:first-child {
        overflow: auto;
      }
      &:last-child {
        justify-content: center;
      }
    }
  }
`;

export const ButtonsContainer = styled(Flex)`
  visibility: hidden;
`;

export const VideoContainer = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.n30};
  border-radius: ${({ theme }) => theme.space}px;
`;
